import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, unref as _unref, isRef as _isRef, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "addAddressBook_container" }
const _hoisted_2 = { style: {"padding":"15px 10px"} }
const _hoisted_3 = { class: "crypto_field" }
const _hoisted_4 = { class: "networkField" }
const _hoisted_5 = { class: "crypto_field" }
const _hoisted_6 = { class: "right_Icons" }
const _hoisted_7 = { class: "crypto_field" }
const _hoisted_8 = { class: "crypto_field" }
const _hoisted_9 = { class: "btn_container" }

import CustomHeader from '@/themes/themeOne/components/common/customHeader.vue';
import { addNewNetwork, callNetworkOptions, NetworkChannelItem, useScanner } from '@/view/withdraw/supportScript';
import { computed, onUnmounted, ref, watch } from 'vue';
import NetworkSelectPopup from './networkSelectPopup.vue';
import MainButton from '../../components/common/mainButton.vue';
import LoadingScreen from '@/components/common/loadingScreen.vue';
import StatusPopup from '@/components/common/statusPopup.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'addAddressPopup',
  emits: ['callNetworkOptions', 'updateAddressbook'],
  setup(__props, { expose: __expose, emit: __emit }) {

const emits = __emit
const address = ref('')
const network = ref('')
const coin = ref('USDT')
const networkList = ref([])
const show = ref(false);
const walletLabel = ref()
const networkPopupRef = ref()
const selectedNetwork = ref()
const isSuccess = ref(false)
const statusRef = ref()
const loadingRef = ref()
const toastContent = ref('')
const buttonActive = computed(() => {
    return (
        address.value !== '' &&
        network.value !== '' &&
        walletLabel.value !== ''
    );
});
const { showScanner, startScanner, stopScanner } = useScanner();
const showError = (message: string) => {
    toastContent.value = message;
    isSuccess.value = false;
    statusRef.value.open()
}
const showSuccess = (message: string) => {
    toastContent.value = message;
    isSuccess.value = true;
    statusRef.value.open()
}
const openPopup = () => {
    show.value = true;
    getNetworkOption()
}

const closePopup = () => {
    address.value = ''
    network.value = ''
    walletLabel.value = ''
    show.value = false;
}

const handleStartScan = () => {
    startScanner('reader', (result) => {
        address.value = result;
    });
};

const showNetworkPopup = () => {
    networkPopupRef.value.openPopup()
}
const getNetworkOption = async(addr?: string) => {
    if (addr) {
        address.value = addr
    }

    const { network_list } = await callNetworkOptions(address.value)
    networkList.value = network_list

}
const saveAddress = async () => {
    const { data } = await addNewNetwork(address.value, walletLabel.value, selectedNetwork.value?.id)
     if (data.code == 200) {
        loadingRef.value.close()
        showSuccess(data.msg)
        emits('updateAddressbook')
        setTimeout(() => {
           closePopup() 
        },2000)
        
    } else {
        loadingRef.value.close()
        showError(data)
    }

}
const setSelectedNetwork = (networkData: any) => {
    selectedNetwork.value = networkData
    network.value = networkData?.channelName
    networkPopupRef.value.closePopup()
}
watch(() => address.value, (newVal) => {
    getNetworkOption(newVal)
})
onUnmounted(() => {
    stopScanner();
});
__expose({
    openPopup
})

return (_ctx: any,_cache: any) => {
  const _component_van_icon = _resolveComponent("van-icon")!
  const _component_van_field = _resolveComponent("van-field")!
  const _component_van_popup = _resolveComponent("van-popup")!

  return (_openBlock(), _createBlock(_component_van_popup, {
    show: show.value,
    "onUpdate:show": _cache[3] || (_cache[3] = ($event: any) => ((show).value = $event)),
    position: "bottom",
    "overlay-style": { overflow: 'hidden' },
    style: {
        minWidth: '100%',
        height: '100%',
        color: '#fff',
    },
    class: "addAddressPopup"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(CustomHeader, {
          text: _ctx.$t('withdraw.addNewAddress'),
          isPopupCloseBackIcon: true,
          onClosePopup: closePopup
        }, null, 8, ["text"]),
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", null, _toDisplayString(_ctx.$t('withdraw.coin')), 1),
            _createElementVNode("div", _hoisted_4, _toDisplayString(coin.value), 1)
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", null, _toDisplayString(_ctx.$t('withdraw.address')), 1),
            _createVNode(_component_van_field, {
              modelValue: address.value,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((address).value = $event)),
              placeholder: _ctx.$t('withdraw.address')
            }, {
              "right-icon": _withCtx(() => [
                _createElementVNode("div", _hoisted_6, [
                  _createVNode(_component_van_icon, {
                    name: "scan",
                    size: "22",
                    onClick: handleStartScan
                  })
                ])
              ]),
              _: 1
            }, 8, ["modelValue", "placeholder"])
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", null, _toDisplayString(_ctx.$t('withdraw.network')), 1),
            _createElementVNode("div", {
              class: "networkField",
              onClick: showNetworkPopup
            }, _toDisplayString(network.value ? network.value : _ctx.$t('withdraw.network')), 1)
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", null, _toDisplayString(_ctx.$t('withdraw.walletLabel')), 1),
            _createVNode(_component_van_field, {
              modelValue: walletLabel.value,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((walletLabel).value = $event)),
              placeholder: _ctx.$t('withdraw.walletLabel')
            }, null, 8, ["modelValue", "placeholder"])
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createVNode(MainButton, {
              title: _ctx.$t('withdraw.save'),
              activeStatus: buttonActive.value,
              onClick: saveAddress
            }, null, 8, ["title", "activeStatus"])
          ])
        ])
      ]),
      _createVNode(_component_van_popup, {
        show: _unref(showScanner),
        "onUpdate:show": _cache[2] || (_cache[2] = ($event: any) => (_isRef(showScanner) ? (showScanner).value = $event : null)),
        class: "transparent-scanner-popup",
        onClosed: _unref(stopScanner),
        "overlay-style": { backgroundColor: 'rgba(0, 0, 0, 0.7)' }
      }, {
        default: _withCtx(() => _cache[4] || (_cache[4] = [
          _createElementVNode("div", { class: "scanner-wrapper" }, [
            _createElementVNode("div", { id: "reader" })
          ], -1)
        ])),
        _: 1
      }, 8, ["show", "onClosed"]),
      _createVNode(NetworkSelectPopup, {
        ref_key: "networkPopupRef",
        ref: networkPopupRef,
        networkList: networkList.value,
        onSelectNetwork: setSelectedNetwork
      }, null, 8, ["networkList"]),
      _createVNode(LoadingScreen, {
        ref_key: "loadingRef",
        ref: loadingRef
      }, null, 512),
      _createVNode(StatusPopup, {
        ref_key: "statusRef",
        ref: statusRef,
        "is-show-success": isSuccess.value,
        content: toastContent.value
      }, null, 8, ["is-show-success", "content"])
    ]),
    _: 1
  }, 8, ["show"]))
}
}

})